<template>
  <div class="el-vue-search-box-container"
       @keydown.up="selectTip('up')"
       @keydown.down="selectTip('down')">
    <div class="search-box-wrapper">
      <el-input
          clearable
          v-model="keyword"
          @keyup.enter="search"
          placeholder="请输入"
          @input="autoComplete">
      </el-input>

    </div>
    <div class="search-tips">
      <ul>
        <li v-for="(tip, index) in tips"
            :key="index"
            @click="changeTip(tip)"
            @mouseover="selectedTip=index"
            :class="{'autocomplete-selected': index === selectedTip}">{{tip.name}}</li>
      </ul>
    </div>
  </div>
</template>
<script>
  import RegisterComponentMixin, {lazyAMapApiLoaderInstance} from 'vue-amap';

  export default {
    name: 'el-amap-search-box',
    mixins: [RegisterComponentMixin],
    props: ['searchOption', 'onSearchResult', 'events', 'default'],
    data() {
      return {
        keyword: this.default || '',
        tips: [],
        selectedTip: -1,
        loaded: false,
        adcode: null,
        // searchOption: {
        //   city: '昆明',
        //   citylimit: true
        // }
      };
    },
    mounted() {
      let _loadApiPromise = lazyAMapApiLoaderInstance.load();
      _loadApiPromise.then(() => {
        this.loaded = true;
        this._onSearchResult = this.onSearchResult;
        // register init event
        this.events && this.events.init && this.events.init({
          autoComplete: this._autoComplete,
          placeSearch: this._placeSearch
        });
        this.searchOption = {
          pageSize: 10,
          pageIndex: 1,
          city: '',
          citylimit: true
        }
      });
    },
    computed: {
      _autoComplete() {
        if (!this.loaded) return;
        // eslint-disable-next-line no-undef
        return new window.AMap.Autocomplete(this.searchOption || {});
      },
      _placeSearch() {
        if (!this.loaded) return;
        // eslint-disable-next-line no-undef
        return new window.AMap.PlaceSearch(this.searchOption || {});
      }
    },
    methods: {
      autoComplete() {
        if (!this.keyword || !this._autoComplete) return;
        this._autoComplete.search(this.keyword, (status, result) => {
          if (status === 'complete') {
            this.tips = result.tips;
          }
        });
        this.$emit('input', this.keyword)
      },
      search() {
        this.tips = [];
        if (!this._placeSearch) return;
        let city = null;
        if (this.searchOption.citylimit && this.searchOption.city) {
          city = this.searchOption.city;
        } else {
          city = this.adcode;
        }
        this._placeSearch.setCity(city || this.searchOption.city);
        this._placeSearch.search(this.keyword, (status, result) => {
          if (result && result.poiList && result.poiList.count) {
            let {poiList: {pois}} = result;
            let LngLats = pois.map(poi => {
              poi.lat = poi.location.lat;
              poi.lng = poi.location.lng;
              return poi;
            });
            this._onSearchResult(LngLats);
          } else if (result.poiList === undefined) {
            throw new Error(result);
          }
        });
        this.$emit('input', this.keyword)
      },
      changeTip(tip) {
        this.adcode = tip.adcode;
        this.keyword = tip.name;
        this.search();
      },
      selectTip(type) {
        if (type === 'up' && this.selectedTip > 0) {
          this.selectedTip -= 1;
          this.keyword = this.tips[this.selectedTip].name;
          this.adcode = this.tips[this.selectedTip].adcode;
        } else if (type === 'down' && this.selectedTip + 1 < this.tips.length) {
          this.selectedTip += 1;
          this.keyword = this.tips[this.selectedTip].name;
          this.adcode = this.tips[this.selectedTip].adcode;
        }
      }
    }
  };
</script>
<style lang="scss">
  .el-vue-search-box-container {
    position: relative;
    height: 45px;
    background: #fff;
    z-index: 10;
    .search-box-wrapper {
      display: flex;
      align-items: center;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
    .search-tips {
      float: right;
      ul {
        padding: 0;
        margin: 4px 0 0 2px;
        position: fixed;
        border: 1px solid #dbdbdb;
        background: #FFF;
        overflow: auto;
        li {
          height: 40px;
          line-height: 40px;
          box-shadow: 0 1px 1px rgba(0,0,0,.1);
          padding: 0 10px;
          cursor: pointer;

          &.autocomplete-selected {
            background: #eee;
          }
        }
      }
    }
  }
</style>
